export const BACKGROUND_TASK_STARTED = "BACKGROUND_TASK_STARTED";
export const BACKGROUND_TASK_PROGRESS = "BACKGROUND_TASK_PROGRESS";
export const BACKGROUND_TASK_FINISHED = "BACKGROUND_TASK_FINISHED";
export const BACKGROUND_TASK_DISMISSED = "BACKGROUND_TASK_DISMISSED";

export type BackgroundTaskKind = "assign" | "remove";

export interface IBackgroundTaskStarted {
  type: typeof BACKGROUND_TASK_STARTED;
  payload: {
    id: string;
    label: string;
    classroomId: string;
    total: number;
    kind: BackgroundTaskKind;
  };
}

export interface IBackgroundTaskProgress {
  type: typeof BACKGROUND_TASK_PROGRESS;
  payload: { id: string; processed: number; failed: number; total: number };
}

export interface IBackgroundTaskFinished {
  type: typeof BACKGROUND_TASK_FINISHED;
  payload: { id: string; processed: number; failed: number; total: number };
}

export interface IBackgroundTaskDismissed {
  type: typeof BACKGROUND_TASK_DISMISSED;
  payload: { id: string };
}
